import { render } from "./proforma-popup.vue?vue&type=template&id=b3b2b7f2&scoped=true&ts=true"
import script from "./proforma-popup.vue?vue&type=script&lang=ts"
export * from "./proforma-popup.vue?vue&type=script&lang=ts"

import "./proforma-popup.vue?vue&type=style&index=0&id=b3b2b7f2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b2b7f2"]])

export default __exports__